import {NOTHING_SELECTED_MEDIA, SET_FABRIC_TEMPLATE, SET_TEMPLATE_SNAPSHOT} from './constants';
import {SET_ALL_ASSETS} from '../constants';
import {INIT_APP} from '~/common/fabric/constants';
import {fabricArtWithHttpsForAllImgPaths} from '~/common/utils/event_utils';

const initialState = {
  artist: '',
  backgroundColor: '',
  backgrounds: [],
  overlays: [],
  displayName: '',
  editableArt: {default: []},
  envelopes: [],
  eventType: '',
  liners: [],
  metaDescription: null,
  premium: false,
  snapshot: null,
  stamps: [],
  stickers: [],
  quickInvite: false,
  templateName: '',
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_FABRIC_TEMPLATE:
      return {...state, ...action.payload};
    case SET_TEMPLATE_SNAPSHOT:
      return {...state, snapshot: action.payload};
    case INIT_APP:
      const _t = action.payload.template;
      return {
        allBackgrounds: action.payload.allBackgrounds,
        allOverlays: action.payload.allOverlays,
        allReveals: action.payload.allReveals,
        allEnvelopes: action.payload.allEnvelopes,
        allLiners: action.payload.allLiners,
        allStamps: action.payload.allStamps,
        allStickers: action.payload.allStickers,
        artist: _t.artist,
        backgroundColor: _t.background_color,
        backgrounds: action.payload.allBackgrounds,
        displayName: _t.display_name,
        editableArt: fabricArtWithHttpsForAllImgPaths(_t.editable_art),
        envelopes: _t.envelopes,
        eventType: _t.event_type,
        liners: _t.liners,
        metaDescription: _t.meta_description,
        premium: _t.premium,
        rsvpOptional: _t.rsvp_optional,
        snapshot: null,
        stamps: action.payload.stamps,
        stickers: _t.stickers,
        templateName: _t.id,
        usedAs: _t.used_as,
        quickInvite: _t.quick_invite,
      };
    case SET_ALL_ASSETS:
      const {
        allStamps,
        allStickers,
        allLiners,
        allBackgrounds,
        allEnvelopes,
        allOverlays,
        allReveals,
      } = action.payload.allAssets;
      return {
        ...state,
        ...{
          allStamps,
          allStickers,
          allLiners,
          allBackgrounds,
          allEnvelopes,
          backgrounds: allBackgrounds,
          stamps: allStamps,
          allOverlays: [NOTHING_SELECTED_MEDIA, ...allOverlays],
          allReveals: [NOTHING_SELECTED_MEDIA, ...allReveals],
        },
      };
    default:
      return state;
  }
};
